var React = require('react');

function Rightarrow (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"points":"30.19 0 0 30.19 97.81 128 0 225.81 30.19 256 158.19 128 30.19 0"}));
}

Rightarrow.defaultProps = {"id":"Capa_1","data-name":"Capa 1","viewBox":"0 0 158.19 256"};

module.exports = Rightarrow;

Rightarrow.default = Rightarrow;
